export const bouncyChestAssets = {
	main: {
		chest: "/spec_bouncy_chest/chest.gif"
	},
	popup: {
		background: "/spec_bouncy_chest/popup-bg-v2.png"
	}
} as const;
